import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Popover } from '@lyearn/ui';
import { PopoverButtonProps } from '@lyearn/ui';
import FilterBody from '@/components/FilterNew/components/Body';

import { EntityFilterProps } from '../types';
import EntityFilterPill from './EntityFilterPill';

const POPOVER_CLASSES: PopoverButtonProps['classes'] = {
  root: 'rounded-full justify-center items-center xs:h-32 xs:me-8',
};

const EntityFilter: React.FC<React.PropsWithChildren<EntityFilterProps>> = (props) => {
  const { t } = useTranslation();
  const {
    open,
    onToggle,
    listConfig,
    children,
    defaultPlaceholder,
    initialSelectedOperator,
    tagValuesStore,
    initialSelectedOptions,
    onChange,
    operators,
    pillProps,
    queryParams,
    uiConfig,
    popoverPosition = 'bottom-start',
    EntityChildrenComponent,
  } = props;
  const { isMobile } = useScreen();
  const selectedFilterValuesData = listConfig.useFilterValues({
    value: initialSelectedOptions,
    tagValuesStore,
    // used only by static entity type to use queryParams.options to show values in pill
    queryParams,
  });

  // at presend we aren't showing header in desktop, so we don't need to pass label
  const label =
    isMobile && defaultPlaceholder
      ? `${t('Common:Filter.FilterBy')} ${defaultPlaceholder}`
      : undefined;

  const { fetching: fetchingSelectedValues } = selectedFilterValuesData;

  return (
    <Popover open={open} onOpenChange={onToggle}>
      {({ open }) => (
        <>
          <Popover.Button classes={POPOVER_CLASSES}>
            {children ?? (
              <EntityFilterPill
                EntityChildrenComponent={EntityChildrenComponent}
                defaultPlaceholder={defaultPlaceholder ?? ''}
                selectedOperator={initialSelectedOperator}
                useFilterValuesResult={selectedFilterValuesData}
                {...pillProps}
              />
            )}
          </Popover.Button>
          {open ? (
            <Popover.Content
              position={popoverPosition}
              renderAs={isMobile ? 'bottom-sheet' : 'popover'}>
              <FilterBody
                key={fetchingSelectedValues ? 'loading' : 'loaded'}
                headerProps={{
                  label,
                  operators,
                }}
                initialSelectedOperator={initialSelectedOperator}
                initialSelectedOptions={selectedFilterValuesData.selectedOptions}
                listConfig={listConfig}
                queryParams={queryParams}
                uiConfig={uiConfig}
                onChange={onChange}
                onToggle={onToggle}
              />
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
};

export default EntityFilter;
